import { Flex } from '@servicetitan/anvil2';
import { WorkflowButtonsStore } from '@servicetitan/financing-workflow-shared';
import { useBreakpoint } from '@servicetitan/financing-utils-shared';
import { PropsWithChildren } from 'react';

export interface FinalStepLayoutProps {
    doneButtonText?: string;
}

export const FinalStepLayout = ({
    children,
    doneButtonText = 'Done',
}: PropsWithChildren<FinalStepLayoutProps>) => {
    const { DoneButton } = WorkflowButtonsStore.useStore();
    const screenSize = useBreakpoint();
    const isNarrowScreen = screenSize.isXs || screenSize.isSm;

    return (
        <Flex direction="column" gap="8" style={{ minHeight: '100%', width: '100%' }}>
            <div style={{ flexGrow: 1 }}>{children}</div>
            <div style={{ flexGrow: 0 }}>
                <Flex justifyContent={isNarrowScreen ? 'stretch' : 'flex-end'}>
                    <DoneButton style={isNarrowScreen ? { width: '100%' } : {}}>
                        {doneButtonText}
                    </DoneButton>
                </Flex>
            </div>
        </Flex>
    );
};
